export const EventAccountRecognitionCheckPerformed = 'Account recognition check performed';
export const EventDetailEntryBegan = 'Detail entry began';
export const EventShippingDetailsFullyEntered = 'Shipping details fully entered';
export const EventShippingMethodStepComplete = 'Shipping method step complete';
export const EventPaymentMethodSelected = 'Payment method selected';
export const EventPaymentDetailsFullyEntered = 'Payment details fully entered';
export const EventPaymentComplete = 'Payment complete';
export const EventPaymentRejected = 'Payment rejected';
export const EventClickPayButton = 'Clicks pay button';